// extracted by mini-css-extract-plugin
module.exports = {"imageContainer":"next-image_imageContainer__8WF2R"};